module.exports = __webpack_public_path__ + "static/media/right-arrow.842ebae7.svg";